import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';

const HEADER = 'X-Custom-Authorization';

function needsToken(url: string): boolean {
  try {
    const path = new URL(url, window.location.origin).pathname;
    return path === '/api/game' || path === '/api/game/';
  } catch {
    return false;
  }
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(SessionService).getUrlToken();
  if (token && needsToken(req.url)) {
    return next(
      req.clone({
        setHeaders: { [HEADER]: `Bearer ${token}` },
        setParams: { token },
        withCredentials: true,
      }),
    );
  }
  return next(req.clone({ withCredentials: true }));
};
